export default class Storage {
    static getToken = () => localStorage.getItem('token');
    static setToken = (token) => localStorage.setItem('token', token);
    static clear = () => localStorage.clear();
}

